// extracted by mini-css-extract-plugin
export default {"pageFornecedorList":"Fornecedor_pageFornecedorList__YOeUR","formCadFornecedor":"Fornecedor_formCadFornecedor__r8dDw","btnEdit":"Fornecedor_btnEdit__t6vF8"};